import { SelectOption } from "@pulseops/common";

export namespace ACViewMetricListForm {
  export interface ACViewMetricSearchedListInfo {
    groupMetric: SelectOption | undefined
  }

  export interface ACEditMetricInfo {
    historyID: string 
    operator: SelectOption | undefined
    operatorValue: string
    ragThreshold: string
    multiplier: string
  }
  export interface ACEditMetricField {
    editingMetricArr: ACEditMetricInfo []
  }
}